import EngineModule               from '../../../EngineModule';
import { NS as StandingPlinthNS } from '../../../components/customers/standing/StandingPlinth/StandingPlinth';

export default () => new EngineModule.LogicalEngineModule({
	type :             'logical',
	id :               'standing-plinth',
	dependencies :     [
		'oms-basket',
		'viewer-planner',
		'viewer-planner-layout-editor',
		'viewer-planner-dimensionsEditor'
	],
	allowedCustomers : [ /* Local MPA */'XUJG0A2TF5', /* Prod */'STAODAZNIS', 'sam1_12345' ],
	insertionPath :    'K',
	generateComponentConfiguration() : StandingPlinthNS.Configuration {
		return {};
	},
	async initialize() {
	}
});
